var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.currentChatMessage && _vm.currentChatMessage.localUser
    ? _c("div", { staticClass: "chat-message-right pb-2 max-w-60" }, [
        _c(
          "div",
          [
            _c(
              "profile-avatar",
              _vm._b(
                { staticClass: "profilepic-options mr-0 mb-3 profilepic" },
                "profile-avatar",
                Object.assign({}, _vm.userDetails),
                false
              )
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "mt-3 mr-1 flex-shrink-1 shadow-sm",
            staticStyle: {
              color: "white",
              "background-color": "#694ed6 !important",
              padding: "6px 6px",
              "border-radius": "10px 0px 10px 10px",
            },
          },
          [_vm._v("\n    " + _vm._s(_vm.currentChatMessage.message) + "\n  ")]
        ),
      ])
    : _vm.loading
    ? _c("div", { staticClass: "chat-message-left pb-2" }, [
        _c("div", [
          _c("img", {
            attrs: {
              height: "40px",
              width: "40px",
              src: require("@Shared/@Assets/img/chat-bot-icon.png"),
              alt: _vm.$t("global.words.proChat"),
            },
          }),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "flex-shrink-1 bg-light rounded max-w-60 py-2 px-3 ms-3",
          },
          [
            _c("div", [
              _c(
                "svg",
                {
                  staticStyle: {
                    margin: "auto",
                    background: "transparent",
                    display: "block",
                  },
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    width: "22px",
                    height: "22px",
                    viewBox: "0 0 100 100",
                    preserveAspectRatio: "xMidYMid",
                  },
                },
                [
                  _c(
                    "circle",
                    { attrs: { cx: "84", cy: "50", r: "10", fill: "#292664" } },
                    [
                      _c("animate", {
                        attrs: {
                          attributeName: "r",
                          repeatCount: "indefinite",
                          dur: "0.25s",
                          calcMode: "spline",
                          keyTimes: "0;1",
                          values: "10;0",
                          keySplines: "0 0.5 0.5 1",
                          begin: "0s",
                        },
                      }),
                      _vm._v(" "),
                      _c("animate", {
                        attrs: {
                          attributeName: "fill",
                          repeatCount: "indefinite",
                          dur: "1s",
                          calcMode: "discrete",
                          keyTimes: "0;0.25;0.5;0.75;1",
                          values: "#292664;#b5ccf1;#94a9ce;#667395;#292664",
                          begin: "0s",
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "circle",
                    { attrs: { cx: "16", cy: "50", r: "10", fill: "#292664" } },
                    [
                      _c("animate", {
                        attrs: {
                          attributeName: "r",
                          repeatCount: "indefinite",
                          dur: "1s",
                          calcMode: "spline",
                          keyTimes: "0;0.25;0.5;0.75;1",
                          values: "0;0;10;10;10",
                          keySplines:
                            "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
                          begin: "0s",
                        },
                      }),
                      _vm._v(" "),
                      _c("animate", {
                        attrs: {
                          attributeName: "cx",
                          repeatCount: "indefinite",
                          dur: "1s",
                          calcMode: "spline",
                          keyTimes: "0;0.25;0.5;0.75;1",
                          values: "16;16;16;50;84",
                          keySplines:
                            "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
                          begin: "0s",
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "circle",
                    { attrs: { cx: "50", cy: "50", r: "10", fill: "#667395" } },
                    [
                      _c("animate", {
                        attrs: {
                          attributeName: "r",
                          repeatCount: "indefinite",
                          dur: "1s",
                          calcMode: "spline",
                          keyTimes: "0;0.25;0.5;0.75;1",
                          values: "0;0;10;10;10",
                          keySplines:
                            "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
                          begin: "-0.25s",
                        },
                      }),
                      _vm._v(" "),
                      _c("animate", {
                        attrs: {
                          attributeName: "cx",
                          repeatCount: "indefinite",
                          dur: "1s",
                          calcMode: "spline",
                          keyTimes: "0;0.25;0.5;0.75;1",
                          values: "16;16;16;50;84",
                          keySplines:
                            "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
                          begin: "-0.25s",
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "circle",
                    { attrs: { cx: "84", cy: "50", r: "10", fill: "#94a9ce" } },
                    [
                      _c("animate", {
                        attrs: {
                          attributeName: "r",
                          repeatCount: "indefinite",
                          dur: "1s",
                          calcMode: "spline",
                          keyTimes: "0;0.25;0.5;0.75;1",
                          values: "0;0;10;10;10",
                          keySplines:
                            "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
                          begin: "-0.5s",
                        },
                      }),
                      _vm._v(" "),
                      _c("animate", {
                        attrs: {
                          attributeName: "cx",
                          repeatCount: "indefinite",
                          dur: "1s",
                          calcMode: "spline",
                          keyTimes: "0;0.25;0.5;0.75;1",
                          values: "16;16;16;50;84",
                          keySplines:
                            "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
                          begin: "-0.5s",
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "circle",
                    { attrs: { cx: "16", cy: "50", r: "10", fill: "#b5ccf1" } },
                    [
                      _c("animate", {
                        attrs: {
                          attributeName: "r",
                          repeatCount: "indefinite",
                          dur: "1s",
                          calcMode: "spline",
                          keyTimes: "0;0.25;0.5;0.75;1",
                          values: "0;0;10;10;10",
                          keySplines:
                            "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
                          begin: "-0.75s",
                        },
                      }),
                      _vm._v(" "),
                      _c("animate", {
                        attrs: {
                          attributeName: "cx",
                          repeatCount: "indefinite",
                          dur: "1s",
                          calcMode: "spline",
                          keyTimes: "0;0.25;0.5;0.75;1",
                          values: "16;16;16;50;84",
                          keySplines:
                            "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
                          begin: "-0.75s",
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ]),
          ]
        ),
      ])
    : _c("div", { staticClass: "chat-message-left d-flex flex-column pt-2" }, [
        _c("div", { staticClass: "w-100 d-flex flex-row" }, [
          _c("div", { staticStyle: { width: "30px" } }, [
            _c("img", {
              attrs: {
                height: "30px",
                width: "30px",
                src: require("@Shared/@Assets/img/chat-bot-icon.png"),
                alt: _vm.$t("global.words.proChat"),
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "mt-3 ml-1 flex-shrink-1 max-w-60 d-flex justify-content-start",
            },
            [
              _c(
                "div",
                {
                  staticClass: "d-flex flex-column",
                  staticStyle: { "background-color": "transparent !important" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "flex-shrink-1 shadow-sm",
                      staticStyle: {
                        "background-color": "#ffffff !important",
                        padding: "6px 6px",
                        margin: "0px 0px",
                        "border-radius": "0px 10px 0px 0px",
                        color: "black",
                        "white-space": "pre-line",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm._f("trim")(_vm.currentChatMessage.message))
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.currentChatMessage.id !== "aa23"
                    ? _c(
                        "div",
                        {
                          staticClass: "d-flex flex-row shadow-sm",
                          staticStyle: {
                            "border-top": "0.5px solid #d3d4db",
                            "background-color": "#ffffff !important",
                            padding: "2px 6px",
                            margin: "0px 0px",
                            "border-radius": "0px 0px 10px 10px",
                          },
                        },
                        [
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip",
                                  value: _vm.$t("global.words.like"),
                                  expression: "$t('global.words.like')",
                                },
                              ],
                              staticClass: "messageButton",
                              class: {
                                btnBg: _vm.currentChatMessage.vote === "liked",
                              },
                              attrs: { id: "like-bt" },
                              on: {
                                click: function ($event) {
                                  return _vm.feedback("liked")
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "svg",
                                attrs: {
                                  width: "auto",
                                  height: "18px",
                                  src: require("@Shared/@Assets/icon/thumbs-up.svg"),
                                  alt: "Like",
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip",
                                  value: _vm.$t("global.words.dislike"),
                                  expression: "$t('global.words.dislike')",
                                },
                              ],
                              staticClass: "messageButton",
                              class: {
                                btnBg:
                                  _vm.currentChatMessage.vote === "disliked",
                              },
                              attrs: { id: "dislike-bt" },
                              on: {
                                click: function ($event) {
                                  return _vm.feedback("disliked")
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "svg",
                                attrs: {
                                  width: "auto",
                                  height: "18px",
                                  src: require("@Shared/@Assets/icon/thumbs-down.svg"),
                                  alt: "Dislike",
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.top",
                                  value: _vm.copyRollOverText,
                                  expression: "copyRollOverText",
                                  modifiers: { top: true },
                                },
                              ],
                              staticClass: "messageButton",
                              attrs: { id: "copy-bt" },
                              on: { click: _vm.copyMessage },
                            },
                            [
                              _c("img", {
                                staticClass: "svg",
                                attrs: {
                                  width: "auto",
                                  height: "18px",
                                  src: require("@Shared/@Assets/icon/copy.svg"),
                                  alt: "Copy",
                                },
                              }),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
            ]
          ),
        ]),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }